export function Subscription() {
  return (
    <p>
      On the website of City Falcon Limited, users are given the opportunity to subscribe to our enterprise's newsletter. The input mask used for this purpose determines what personal data are transmitted, as well as when the newsletter is ordered from the controller.
      <br />
      <br />
      If you agree, we may contact you:
      <ul>
        <li> with offers and information about our products or services</li>
        <li> with offers and information about selected partners' products or services</li>
        <li> for customer research eg to help improve our services</li>
      </ul>
      We like to hear your views to help us improve our service. From time to time, we may contact you to ask your opinions. Again, if you do not want to be contacted for this purpose, make your choice on the 
      <a href="/preferences">
        {' '}
        Preferences
      </a>
      {' '}
      page.
    </p>
  );
}

export default Subscription;
